module.exports = __webpack_public_path__ + "img/Dont_Shadows_and_gradients.da5f94eb.png";